import React from 'react'

const HowItWorksSection = ({ steps }) => (
  <section className='how-section' id='how'>
    <div className='landing-shell'>
      <p className='section-label'>Simple as honey</p>
      <h2 className='section-title'>
        How Co-bee <em>works</em>
      </h2>

      <div className='how-section__grid'>
        {steps.map((step) => (
          <article key={step.number} className='how-step landing-reveal'>
            <div className='how-step__number'>{step.number}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default HowItWorksSection
